<template>
    <q-table :title="title"
             :loading="loading"
             :columns="columns"
             :visible-columns="columnsVisible"
             :data="dataSource"
             :filter="filter"
             row-key="Id"
             :pagination.sync="pagination"
             :rows-per-page-options="[ 5, 10, 15, 25, 50, 100 ]"
             @request="onRequest">

            <template v-slot:top>
                <q-toolbar v-if="true">
                    <div class="q-table__title">
                        {{ title }}
                    </div>
                    <q-space></q-space>
                    <q-input outlined dense clearable clear-icon="close" v-model="filter" placeholder="Search" debounce="300" style="width:300px">
                        <template v-slot:prepend>
                            <q-icon name="search"></q-icon>
                        </template>
                    </q-input>
                    <q-separator dark vertical></q-separator>
                    <q-btn label="Create"
                           icon-right="add"
                           color="primary"
                           v-show="channelSettings.SenderId > 0 && channelSettings.ReceiverId > 0"
                           @click="onCreateActionClick()">
                    </q-btn>
                    <q-separator dark vertical></q-separator>
                    <q-btn label="Import"
                           icon-right="file_upload"
                           color="primary"
                           v-show="channelSettings.SenderId > 0 && channelSettings.ReceiverId > 0"
                           @click="onImportActionClick()">
                    </q-btn>
                    <q-separator dark vertical></q-separator>
                    <q-btn label="Export"
                           icon-right="file_download"
                           color="primary"
                           v-show="channelSettings.SenderId > 0 && channelSettings.ReceiverId > 0 && dataSource && dataSource.length > 0"
                           @click="onExportActionClick()">
                    </q-btn>
                </q-toolbar>
            </template>

            <template v-slot:body-cell-Actions="props">
                <q-td :props="props" auto-width>
                    <div class="q-gutter-xs">
                        <q-btn label="Edit"
                               color="primary"
                               @click="onEditActionClick(props.key, props.rowIndex, props.row)">
                        </q-btn>
                        <q-btn label="Bundle"
                               color="primary"
                               @click="onEditBundleClick(props.key, props.rowIndex, props.row)">
                        </q-btn>
                        <q-btn label="Delete"
                               color="primary"
                               @click="onDeleteActionClick(props.key, props.rowIndex, props.row)">

                        </q-btn>

                    </div>
                </q-td>
            </template>
        </q-table>
</template>

<script>
    export { default } from './sku-map-trading-items-list-screen.js'
</script>